// extracted by mini-css-extract-plugin
module.exports = {"files":"ContractorFiles_files__3xewU","newFile":"ContractorFiles_newFile__q1bCX","removedFile":"ContractorFiles_removedFile__23OGw"};